import React from 'react';
import PropTypes from 'prop-types';
import { genEditListingToken, sendCommunicationCS } from '../../../api';
import { server } from '../../../config';
import styles from './ShareLinkModal.module.scss';
import { clickTracker } from '../../../lib/common';

const ShareLinkModal = ({ popupRef, handleCloseShareLinkPopup, setAlert }) => {
  const businessData = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));

  const getURLVal = async () => {
    try {
      const params = {
        eid: profile?.empCode || '',
        docId: businessData?.docId || '',
        city: businessData?.city || '',
        mobile: profile?.mobile || '',
        empName: profile?.full_name || '',
        backUrl: encodeURI(window.location.href),
      };
      const genioFlag = 1;
      const { token, closedDown } = await genEditListingToken(params, genioFlag);
      if (closedDown) {
        return '';
      }
      return `${server.editListingRedirectionUrl}?tid=${token}&eid=${profile?.empCode}&salesEmp=1&user_type=TME&isandroid=0&sso_dept=SALES&team_type=HD&typeOfEmployee=tme&vertical=genioCS`;
    } catch (err) {
      console.log('Err in getEditListingURLValue', err);
      return '';
    }
  };

  const handleShareLinkClick = async () => {
    await clickTracker('issue_shareicon', 'geniocs_faq_issue');
    const urlVal = await getURLVal();
    console.log('urlVal', urlVal);
    try {
      const params = {
        ...businessData,
        shareLinkType: 'editListingShareLink',
        faqType: 'edit_my_business',
      };
      const response = await sendCommunicationCS(params);
      setAlert({
        message: response?.errorCode === 0 ? response?.result : response?.message || 'Message not sent',
        status: response?.errorCode === 0,
      });
    } catch (err) {
      console.log('err sendCommunicationCS', err);
    }
    handleCloseShareLinkPopup();
  };
  return (
    <section className={`cs_modal ${styles.ShareLinkModal} `}>
      <div ref={popupRef} className={`cs_modal_content cs_modal_animation fadeInUpTop  ${styles.ModalContent}`}>
        <div className="cs_modal_body p-15">
          <div className="font16 fw700 color111">Share Link</div>
          <div className="font13 fw500 color111 mt-5">Do you want to share the link with owner ?</div>
          <div className={`${styles.ShareLinkModal__BtnGroup} mt-15`}>
            <button
              onClick={handleCloseShareLinkPopup}
              type="button"
              className={`${styles.ShareLinkModal__Button} blue_whitefill_animate font13 fw600 color007`}
            >
              Cancel
            </button>
            <button
              onClick={handleShareLinkClick}
              type="button"
              className={`${styles.ShareLinkModal__Button} bluefill_animate font13 fw600 colorFFF`}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShareLinkModal;

ShareLinkModal.propTypes = {
  handleCloseShareLinkPopup: PropTypes.func,
  popupRef: PropTypes.object,
  setAlert: PropTypes.func,
};
